import React from 'react';
import i18next from 'i18next';

import type { AppRouteGroup } from 'app/store/components/NavigationUtils';
import { lazyRetry } from 'app/main/components';

import en from './i18n/en';
import it from './i18n/it';

const VersionUpdatePage = lazyRetry(() => import('./VersionUpdatePage'));

i18next.addResourceBundle('en', 'core', en);
i18next.addResourceBundle('it', 'core', it);

const routes: AppRouteGroup = {
	settings: {
		layout: {
			style: 'layout1',
			config: {
				mode: 'contained',
				navbar: { display: false },
				toolbar: { display: false },
				footer: { display: false },
				leftSidePanel: { display: false },
				rightSidePanel: { display: false }
			}
		}
	},
	routes: [
		{
			path: 'version-update',
			element: <VersionUpdatePage />
		}
	]
};

export default routes;
